export function el(html) {
  const t = document.createElement('template');
  t.innerHTML = html.trim();
  return t.content.firstElementChild;
}

// Content is authored in /admin, so it is escaped on the way into markup
// rather than trusted.
export function esc(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;');
}

// Renders an uploaded image when the item has one, and the design's hatched
// placeholder with its hint text when it does not.
export function ph(item, { className = '', hintKey = 'hint' } = {}) {
  const image = item?.image;
  const hint = item?.[hintKey] ?? item?.hint ?? '';
  const cls = `ph${className ? ` ${className}` : ''}`;
  return image
    ? `<div class="${cls}"><img src="${esc(image)}" alt="${esc(hint)}" loading="lazy" /></div>`
    : `<div class="${cls}"><span>${esc(hint)}</span></div>`;
}

// Two-step confirmation in the button itself. Native confirm() blocks the page
// and reads as an error dialog for what is an ordinary, reversible edit.
export function confirmAction(button, { label = 'Sure?', timeout = 4000 }, onConfirm) {
  const original = button.textContent;
  let armed = false;
  let timer = null;

  const reset = () => {
    armed = false;
    clearTimeout(timer);
    button.textContent = original;
    button.classList.remove('is-armed');
  };

  button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!armed) {
      armed = true;
      button.textContent = label;
      button.classList.add('is-armed');
      timer = setTimeout(reset, timeout);
      return;
    }

    reset();
    onConfirm();
  });

  return reset;
}
